import { VraccountreportPage } from "./../vraccountreport/vraccountreport";
import { VrprofitreportPage } from "./../vrprofitreport/vrprofitreport";
import { VrchasereportPage } from "./../vrchasereport/vrchasereport";
import { VrgamereportPage } from "./../vrgamereport/vrgamereport";
import { Component } from "@angular/core";
import { NavController, PopoverController, Events, App } from "ionic-angular";
import { StorageService } from "../../providers/storage.service";
import { UserModel } from "../../models/user.model";
import { SysconfigModel } from "../../models/user.model";

import { SelfReport } from "../selfreport/selfreport";
import { RechargePage } from "../recharge/recharge";
import { DepositRecordPage } from "../deposit-record/deposit-record";
import { TransferPage } from "../transfer/transfer";
import { TransferRecordPage } from "../transfer-record/transfer-record";
import { WithdrawPage } from "../withdraw/withdraw";
import { WithdrawRecordPage } from "../withdraw-record/withdraw-record";
import { AccountChange } from "../accountchange/accountchange";
import { ChaseReport } from "../chasereport/chasereport";
import { DailyWagesReport } from "../dailywagesreport/dailywagesreport";
import { NormalReport } from "../normalreport/normalreport";
import { TeamReport } from "../teamreport/teamreport";
import { TeamManagerList } from "../teammanager/teammanager";
import { UserBankList } from "../userbanks/userbanklist";
import { OpenAccountPage } from "../open-account/open-account";
import { OutboxPage } from "../outbox/outbox";
import { InboxPage } from "../inbox/inbox";
import { SecretquestionPage } from "../secretquestion/secretquestion";
import { DailywagesetPage } from "../dailywageset/dailywageset";
import { InAppBrowser } from "@ionic-native/in-app-browser";

import { SendMessagePage } from "../send-message/send-message";
import { SigninPage } from "../signin/signin";
import { PasswordPage } from "../password/password";
import { WeiXinPage } from "./weixin";
import { AppConfig } from "../../app/app.config";
import { UserVarifyService } from "./../../services/userVarify.service";
import { LoaddingService } from "./../../providers/loadding.service";

import * as $ from "jquery";
import { GooglePage } from "../google/google";
import { ImPage } from "../im/im";
import { ChatService } from "../../services/chat.service";
import { ImService } from "../im/im.service";
import { AlertService } from "../../providers/alert.service";
import { ModifyPwsPage } from "../modify-pws/modify-pws";
import { RevisePage } from "../password/revise";

@Component({
  selector: "page-account",
  templateUrl: "account.html",
  providers: [UserVarifyService]
})
export class AccountPage {
  appConfig = AppConfig;
  pages: Pages[] = [
    {
      name: "个人中心",
      child: [
        { childName: "游戏记录", component: NormalReport, icon: "ios-create" },
        { childName: "追号记录", component: ChaseReport, icon: "md-copy" },
        { childName: "银行卡/钱包管理", component: UserBankList, icon: "card" }
      ]
    },
    {
      name: "消息中心",
      child: [
        // { "childName": "发件箱", component: OutboxPage, icon: "ios-list-box" },
        // { "childName": "收件箱", component: InboxPage, icon: "ios-list-box-outline" },
        // { "childName": "发消息", component: SendMessagePage, icon: "send" },
        { childName: "上下级聊天", component: ImPage, icon: "md-chatboxes" }
      ]
    },
    {
      name: "财务中心",
      child: [
        {
          childName: "充值",
          component: RechargePage,
          icon: "md-tablet-portrait"
        },
        { childName: "提现", component: WithdrawPage, icon: "nutrition" },
        { childName: "转账", component: TransferPage, icon: "basket" },
        {
          childName: "充值记录",
          component: DepositRecordPage,
          icon: "ios-clipboard"
        },
        {
          childName: "提现记录",
          component: WithdrawRecordPage,
          icon: "ios-copy"
        },
        {
          childName: "转账记录",
          component: TransferRecordPage,
          icon: "md-bookmarks"
        }
      ]
    },
    {
      name: "代理中心",
      child: [
        { childName: "开户中心", component: OpenAccountPage, icon: "key" },
        { childName: "团队管理", component: TeamManagerList, icon: "build" },
        { childName: "密码管理", component: PasswordPage, icon: "settings" },
        {
          childName: "密保管理",
          component: SecretquestionPage,
          icon: "construct"
        },
        { childName: "Google验证", component: GooglePage, icon: "logo-google" },
        {
          childName: "日工资设置",
          component: DailywagesetPage,
          icon: "list-box"
        }
      ]
    },
    {
      name: "报表中心",
      child: [
        { childName: "主账户报表", component: SelfReport, icon: "md-cash" },
        { childName: "团队报表", component: TeamReport, icon: "calculator" },
        {
          childName: "账变记录",
          component: AccountChange,
          icon: "md-clipboard"
        },
        {
          childName: "日工资报表",
          component: DailyWagesReport,
          icon: "ios-contrast"
        }
      ]
    }
  ];
  // 验证是否设置资金密码
  GoogleCkParams = { isShow: false, pwd: "", chkSign: "0" };
  // 验证资金密码是否正确
  googleCkParams = { isShow: false, pwd: "", chkSign: "1" };
  isSetMoneyPwd: boolean = false;
  gooleserect: boolean = false;
  userInformation; //this.storage.read<UserModel>("User");
  key: string;

  unreadMessage: number; //未读消息
  isShowUnreadMessage: boolean = false; //是否显示未读消息的小红点
  getMessageCount;
  totalMessage: number = 0;
  userMoney: number = 0;

  constructor(
    private storage: StorageService,
    private config: AppConfig,
    public navCtrl: NavController,
    private popCtrl: PopoverController,
    private userService: UserVarifyService,
    private iab: InAppBrowser,
    private chatService: ChatService,
    private events: Events,
    private alert: AlertService,
    private appCtrl: App,
  ) {
    this.unreadMessage = 0;
    if (AppConfig.User) {
      this.userInformation = AppConfig.User;
    }
  }
  ionViewDidLoad() {
    //会员不显示开户中心，团队管理，团队列表;没有配置日工资的代理不需要显示日工资
    if (this.appConfig.User.UserType == "0") {
      let center = this.pages.find(s => s.name == "代理中心");
      for (let i = 0; i < center.child.length; i++) {
        if (center.child[i].childName == "开户中心") {
          center.child.splice(i, 1);
        }
        if (center.child[i].childName == "团队管理") {
          center.child.splice(i, 1);
        }
        if (center.child[i].childName == "日工资设置") {
          center.child.splice(i, 1);
        }
      }
      let record = this.pages.find(s => s.name == "报表中心");
      for (let i = 0; i < record.child.length; i++) {
        if (record.child[i].childName == "团队报表") {
          record.child.splice(i, 1);
        }
        if (record.child[i].childName == "日工资报表") {
          record.child.splice(i, 1);
        }
      }
    }
    if (!this.appConfig.User.CanDailyWages) {
      let record = this.pages.find(s => s.name == "报表中心");
      for (let i = 0; i < record.child.length; i++) {
        if (record.child[i].childName == "日工资报表") {
          record.child.splice(i, 1);
        }
      }
      let center = this.pages.find(s => s.name == "代理中心");
      for (let i = 0; i < center.child.length; i++) {
        if (center.child[i].childName == "日工资设置") {
          center.child.splice(i, 1);
        }
      }
    }

    //判断vr是否开启
    if (AppConfig.VrIsOpen) {
      let vr: Pages = {
        name: "VR彩票报表",
        child: [
          {
            childName: "VR游戏记录",
            component: VrgamereportPage,
            icon: "ios-create"
          },
          {
            childName: "VR追号记录",
            component: VrchasereportPage,
            icon: "md-bookmarks"
          },
          {
            childName: "VR盈亏统计",
            component: VrprofitreportPage,
            icon: "md-cash"
          },
          {
            childName: "VR帐变流水",
            component: VraccountreportPage,
            icon: "md-clipboard"
          }
        ]
      };
      this.pages.push(vr);
    }
  }

  // 进入其他页面，清除轮询
  ionViewDidLeave() {
    clearInterval(AppConfig.balanceTimer);
    clearInterval(ImService.getMessageCount);
    this.storage.remove("totalMessage");
  }

  ionViewDidEnter() {
    clearInterval(ImService.getMessageCount);
    this.getUnreadMessage();
    ImService.getMessageCount = setInterval(() => {
      this.getUnreadMessage();
    }, 7000);
    this.reUserMoney();
    AppConfig.balanceTimer = setInterval(() => {
      this.reUserMoney();
    }, 5000);
  }

  /**
   * 获取未读消息总数  David 2019-08-03
   */
  getUnreadMessage() {
    this.chatService.getUnreadMessageCount().then(
      s => {
        let totalMsg: any = this.storage.read("totalMessage");
        if (totalMsg >= 0 && s.Parameter2 !== 0) {
          this.storage.write("totalMessage", s.Parameter2);
          this.totalMessage = s.Parameter2;
          this.isShowUnreadMessage = true;
          this.unreadMessage = s.Parameter2;
        } else {
          this.storage.write("totalMessage", s.Parameter2);
          this.unreadMessage = s.Parameter2;
          if (this.unreadMessage > 0) {
            this.isShowUnreadMessage = true;
          } else {
            this.isShowUnreadMessage = false;
          }
        }
        this.events.publish("unreadMessage", this.unreadMessage);
      }
    ).catch(err => {
      if (err.status == 331) {
        clearInterval(ImService.getMessageCount);
      } else if (err.status === 401 || err.status === 403) {
        this.alert.showAlert("验证已失效，您需要退出重新登录!");
        localStorage.clear();
        this.appCtrl.getRootNav().setRoot(SigninPage);

      }
    });
  }

  openPage(page) {
    if (page.childName == '充值' || page.childName == '提现') {
      const func = () => this.navCtrl.push(page.component);
      this.verifyBindStatus(func);
    } else if (page.childName == '银行卡/钱包管理') {
      const isBindPassword = this.storage.read('isBindPassword');
      if (!isBindPassword) {
        this.alert.showConfirm('您还没有绑定资金密码，前往绑定', () => {
          this.navCtrl.push(RevisePage, { information: 1 });
        }, '提示', null, false);
      } else {
        this.navCtrl.push(page.component);
      }
    } else {
      this.navCtrl.push(page.component);
    }
  }

  //用户余额刷新
  reUserMoney() {
    // let load = this.loadding.showLoding();
    this.userService.getUserMoney().then(s => {
      this.userMoney = s;
      let user = this.storage.read<UserModel>("User");
      $.extend(user, { UserMoney: s });
      this.storage.write("User", user);
      AppConfig.User = user;
    });
    // this.loadding.closeLoading(load);
  }

  verifyBindStatus(func = null) {
    const isBindPassword = this.storage.localStorageGet('isBindPassword');
    let userBanksCache = this.storage.localStorageGet('userBanksCache') ? this.storage.localStorageGet('userBanksCache') : [];
    const isBindCard = Boolean(userBanksCache.length);
    if (!isBindPassword) {
      this.alert.showConfirm('您还没有绑定资金密码，前往绑定', () => {
        this.navCtrl.push(RevisePage, { information: 1 });
      }, '提示', null, false);
    } else if (!isBindCard) {
      this.alert.showConfirm("请先绑定钱包地址/银行卡！", () => {
        this.navCtrl.push(UserBankList);
      }, '提示', null, false);
    } else {
      func && func();
    }
  }

  //充值按钮
  //chen 2017-01-12
  deposit() {
    const func = () => this.navCtrl.push(RechargePage);
    this.verifyBindStatus(func);
  }

  //提现按钮
  //chen 2017-01-12
  withdraw() {
    const func = () => this.navCtrl.push(WithdrawPage);
    this.verifyBindStatus(func);
  }

  //退出登录
  //chen 2017-01-12
  exit() {
    clearInterval(AppConfig.balanceTimer);
    this.storage.remove("User");
    this.storage.remove("id_token");
    this.storage.remove("lotterys");
    this.storage.remove("token");
    this.storage.clear();
    this.navCtrl.push(SigninPage);
  }

  //在线客服
  //chen 2017-01-16
  customer() {
    let connect = this.storage.read<SysconfigModel>("sysconfig");
    this.config.openUrl(connect.CustomerServiceUrl);
  }

  //微信客服
  //chen 2017-02-28
  weiCustomer(event) {
    let popover = this.popCtrl.create(WeiXinPage);
    popover.present({
      ev: event
    });
  }
}

class Pages {
  name: string;
  child: PageChilds[];
}
class PageChilds {
  childName: string;
  component: any;
  icon: string;
}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts